export const collections = {
  items: "items",
  todos: "todos",
};

export const secondaryColor = "var(--color-link-text)";
export const primaryColor = "var(--color-accent)";
export const golobalFont = `var(--font-heading)`;
export const labelColors = "var(--color-accent)";
export const siteNames = {
  main: "Studio Dome Dubbing",
  localization: "Studio Dome Dubbing Localize",
  audiobook: "Studio Dome Dubbing Speak",
};

export const getSiteName = (pathname) => {
  if (pathname.startsWith("/audiobooks")) {
    return siteNames.audiobook;
  }

  const localizationPrefixes = [
    "/admin",
    "/landing",
    "/work",
    "/workpages",
    "/project",
    "/actions",
    "/results",
    "/createproject",
  ];

  if (localizationPrefixes.some((prefix) => pathname.startsWith(prefix))) {
    return siteNames.localization;
  }

  return siteNames.main;
};
export const companyName = "Studio Dome";
